define('modules/editor/views/controls/groupbox',['require','exports','module','base/itemview'],function(require, exports, module){
  "use strict";
  var BaseView = require("base/itemview");

  var GroupVBar = BaseView.extend({
    className: "resize-box group-box v-side",
    noTemplate: true,
    setPosition: function(top, left, height){
      this.$el.css({
        top: top,
        left: left,
        height: height + "px",
        zIndex: 2001
      });
    }
  });
  var GroupHBar = BaseView.extend({
    className: "resize-box group-box h-side",
    noTemplate: true,
    setPosition: function(top, left, width){
      this.$el.css({
        top: top,
        left: left,
        width: width + "px",
        zIndex: 2001
      });
    }
  });

  module.exports = {
    verticalBar: GroupVBar,
    horizontalBar: GroupHBar
  };
});
